import React from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonButtons,
  IonButton,
  IonModal,
  IonInput,
  IonSpinner,
  IonText,
  IonAlert,
} from '@ionic/react';
import { addOutline, closeOutline, locationOutline, trashOutline } from 'ionicons/icons';
import { useSitesPage } from '../../application/use-cases/sites/useSitesPage';
import LocationPicker from '../components/map/LocationPicker';

const Sites: React.FC = () => {
  const {
    sites,
    loading,
    error,
    showAdd,
    setShowAdd,
    newName,
    setNewName,
    newLat,
    newLng,
    setNewLocation,
    creating,
    formError,
    openAdd,
    handleCreate,
    deletingSiteId,
    setDeletingSiteId,
    handleDelete,
    editingSite,
    setEditingSite,
    editName,
    setEditName,
    editLat,
    editLng,
    setEditLocation,
    saving,
    editError,
    openEdit,
    handleUpdate,
  } = useSitesPage();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Mis campos</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={openAdd}>
              <IonIcon icon={addOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}

        {!loading && error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}

        {!loading && !error && sites.length === 0 && (
          <IonText color="medium">
            <p className="ion-padding">
              Todavía no cargaste ningún campo (establecimiento). Tocá + para crear el primero.
            </p>
          </IonText>
        )}

        <IonList>
          {sites.map((site) => (
            <IonItem key={site.id} button detail={false} onClick={() => openEdit(site)}>
              <IonIcon icon={locationOutline} slot="start" />
              <IonLabel>
                <h2>{site.name}</h2>
                {site.lat !== null && site.lng !== null && (
                  <p>
                    {site.lat.toFixed(4)}, {site.lng.toFixed(4)}
                  </p>
                )}
              </IonLabel>
              <button
                className="delete-icon-btn"
                slot="end"
                onClick={(e) => { e.stopPropagation(); setDeletingSiteId(site.id); }}
                aria-label={`Eliminar ${site.name}`}
              >
                <IonIcon icon={trashOutline} />
              </button>
            </IonItem>
          ))}
        </IonList>

        <IonModal isOpen={showAdd} onDidDismiss={() => setShowAdd(false)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Agregar campo</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setShowAdd(false)}>
                  <IonIcon icon={closeOutline} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem>
              <IonInput
                placeholder="Nombre (ej. Campo Los Álamos, Casa)"
                value={newName}
                onIonInput={(e) => setNewName(e.detail.value ?? '')}
              />
            </IonItem>

            <IonText color="medium">
              <p style={{ fontSize: 13, margin: '12px 2px 0' }}>
                Buscá la localidad o tocá el mapa para marcar el punto de referencia del campo (opcional).
              </p>
            </IonText>
            <LocationPicker lat={newLat} lng={newLng} onChange={setNewLocation} />

            {formError && (
              <IonText color="danger">
                <p>{formError}</p>
              </IonText>
            )}

            <IonButton expand="block" style={{ marginTop: 16 }} onClick={handleCreate} disabled={creating}>
              {creating ? 'Creando...' : 'Crear'}
            </IonButton>
          </IonContent>
        </IonModal>

        <IonModal isOpen={!!editingSite} onDidDismiss={() => setEditingSite(null)}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Editar campo</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setEditingSite(null)}>
                  <IonIcon icon={closeOutline} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem>
              <IonInput
                placeholder="Nombre (ej. Campo Los Álamos, Casa)"
                value={editName}
                onIonInput={(e) => setEditName(e.detail.value ?? '')}
              />
            </IonItem>

            <IonText color="medium">
              <p style={{ fontSize: 13, margin: '12px 2px 0' }}>
                Buscá la localidad o tocá el mapa para actualizar el punto de referencia del campo.
              </p>
            </IonText>
            <LocationPicker lat={editLat} lng={editLng} onChange={setEditLocation} />

            {editError && (
              <IonText color="danger">
                <p>{editError}</p>
              </IonText>
            )}

            <IonButton expand="block" style={{ marginTop: 16 }} onClick={handleUpdate} disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </IonButton>
          </IonContent>
        </IonModal>

        <IonAlert
          isOpen={!!deletingSiteId}
          onDidDismiss={() => setDeletingSiteId(null)}
          header="¿Eliminar este campo?"
          message="Las estaciones que tenía asignadas no se borran, pero quedan sin campo."
          buttons={[
            { text: 'Cancelar', role: 'cancel' },
            { text: 'Eliminar', role: 'destructive', handler: handleDelete },
          ]}
        />
      </IonContent>
    </IonPage>
  );
};

export default Sites;
